import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ActionMenuItem } from '../../models/interfaces';

const StyledMenu = styled((props: MenuProps) => (
  <Menu elevation={0} {...props} />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px !important',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

interface ContextMenuPosition {
  mouseX: number;
  mouseY: number;
}

interface IProps {
  open: boolean;
  handleClose: () => void;
  menuItems: ActionMenuItem[];
  position: ContextMenuPosition | null;
}

export default function ContextMenu(props: IProps) {
  const { open, handleClose, menuItems, position } = props;

  const handleClickMenuItem = (callback?: () => void | null) => {
    callback && callback();
  };

  return (
    <StyledMenu
      open={open}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        position !== null
          ? { top: position.mouseY, left: position.mouseX }
          : undefined
      }
    >
      {menuItems.map((item, index) => (
        <MenuItem
          onClick={() => handleClickMenuItem(item?.callback)}
          disableRipple
          key={index}
          disabled={item?.disabled}
        >
          {item?.icon}
          {item?.text}
        </MenuItem>
      ))}
    </StyledMenu>
  );
}
